export default __webpack_public_path__ + "static/public-safety-accomplishment-2-5e3cd58f77088cfa50a6cea5b9bf1b88.webp";